var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.franchiseId)?_c('createClinic',{attrs:{"backRoute":"SuperAdminClinic","franchiseId":_vm.franchiseId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }